{
  "Can i translate this ?": "Могу ли да преведем ово?",
  "Accounts": "Повезани налози",
  "Site settings": "Подешавања сајта",
  "Language": "Језик",
  "Enable Marmaid": "Омогући Мермаид",
  "Enable Blur": "Омогући замућење",
  "Enable Animations": "Омогући анимације",
  "Personal information": "Лична информација",
  "NO": "Не",
  "YES": "ДА",
  "General": "Генерал",
  "Profile": "Профил",
  "Notifications": "Обавештења",
  "Identity": "Идентитет",
  "Tokens": "Токенс",
  "Instances": "Инстанце",
  "Domains": "Домаинс",
  "Sessions": "Сесије",
  "My Sessions": "Моје сесије",
  "No projects": "Нема пројеката",
  "Create project": "Креирајте пројекат",
  "Projects": "Пројекти",
  "Project name": "Име пројекта",
  "Project description": "Опис пројекта",
  "Select team": "Изаберите тим",
  "Set unique description for project": "Поставите јединствени опис за пројекат",
  "Please fill out this field.": "Молим вас попуните ово поље.",
  "Create": "Креирај",
  "OwnedBy": "У власништву",
  "Open": "Отвори",
  "Settings": "Подешавања",
  "Apps": "Аппс",
  "Logout": "Одјавити се",
  "Admin": "Админ",
  "Iot": "Иот",
  "Name": "Име",
  "Email": "Емаил",
  "You have being mentioned inside": "Споменути сте унутра",
  "from project": "из пројекта",
  "by": "од стране",
  "You have being invited as member inside project": "Позвани сте као члан унутар пројекта",
  "to build awesome things": "да изградимо сјајне ствари"
}